import type { VariantProps } from 'class-variance-authority';
import { ChevronDown } from 'lucide-react';
import type { ComponentProps } from 'react';

import { fieldControlVariants } from '@platform/ui/components/input';
import { cn } from '@platform/ui/lib/utils';

export interface SelectProps extends Omit<ComponentProps<'select'>, 'size'>, VariantProps<typeof fieldControlVariants> {
    invalid?: boolean;
}

/**
 * A form select stays the browser's own control (ADR 0004 §2): a phone opens its
 * native picker, the value submits with the form, and assistive technology
 * already knows how to read it. Only the chrome is ours — the field shape and a
 * chevron that follows the theme. `className` sizes the wrapper.
 */
export function Select({ className, size, invalid, children, ...props }: SelectProps) {
    return (
        <span data-slot="select" className={cn('relative inline-flex w-full', className)}>
            <select aria-invalid={invalid || undefined} {...props} className={cn(fieldControlVariants({ size }), 'appearance-none pr-10')}>
                {children}
            </select>
            <ChevronDown aria-hidden="true" className="pointer-events-none absolute top-1/2 right-3 size-4 -translate-y-1/2 text-muted-foreground" />
        </span>
    );
}
